<template>
  <button
    type="button"
    class="navbar-toggler"
    :class="{ toggled: isShowSidebar }"
  >
    <span class="navbar-toggler-bar bar1" />
    <span class="navbar-toggler-bar bar2" />
    <span class="navbar-toggler-bar bar3" />
  </button>
</template>

<script lang="ts">
export default {
  name: 'NavbarToggleButton',
  props: {
    isShowSidebar: Boolean,
  },
};
</script>

<style></style>
